import { h } from 'vue';

const body = '<h4>Show options for curvature combs</h4> <p>Configure the amount and length of rendered curvature combs.</p>';

export function ShowCurvatureCombsOptionsTooltip() {
    return h('div', { innerHTML: body });
}
